/* eslint-disable react/require-default-props */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { IconButton } from '../../../styles/ui/Button';

const Wrap = styled.div`
   position: absolute;
   top: 0;
   bottom: 0;
   ${(p) => (p.$side === 'right' ? 'right: 0;' : 'left: 0;')}
   width: 42px;
   display: flex;
   align-items: center;
   justify-content: center;
   z-index: 3;
`;

const Btn = styled(IconButton)`
   width: 28px;
   height: 28px;
`;

const Overlay = styled.div`
   position: absolute;
   inset: 0;
   z-index: 2;
   pointer-events: none;

   border-radius: 12px;

   opacity: ${(p) => (p.$show ? 1 : 0)};
   transition: opacity 180ms ease;

   background: ${(p) =>
      p.$side === 'left'
         ? 'linear-gradient(90deg, rgba(209, 20, 20, 0.55) 0%, rgba(0,0,0,0) 85%)'
         : 'linear-gradient(270deg, rgba(209, 20, 20, 0.55) 0%, rgba(0,0,0,0) 85%)'};
`;

const OverlayText = styled.div`
   position: absolute;
   top: 50%;
   transform: translateY(-50%)
      translateX(
         ${(p) => (p.$show ? '0px' : p.$side === 'left' ? '-8px' : '8px')}
      );
   opacity: ${(p) => (p.$show ? 1 : 0)};

   transition:
      opacity 180ms ease,
      transform 180ms ease;

   color: #fff;
   font-size: 12px;
   font-weight: 700;
   letter-spacing: 0.2px;
   pointer-events: none;
   z-index: 2;

   ${(p) => (p.$side === 'left' ? 'left: 42px;' : 'right: 42px;')}
   white-space: nowrap;
`;

export default function InputClearButton({
   visible = false,
   side = 'right',
   hoverText = 'Limpar',
   onClear = undefined,
   disabled = false,
}) {
   const [hover, setHover] = useState(false);
   const [armed, setArmed] = useState(false);

   const showOverlay = useMemo(() => visible && hover, [visible, hover]);

   useEffect(() => {
      setHover(false);
      setArmed(false);

      if (!visible) return undefined;

      let done = false;

      const onMove = () => {
         if (done) return;
         done = true;
         setArmed(true);
         window.removeEventListener('mousemove', onMove);
      };

      window.addEventListener('mousemove', onMove);

      return () => window.removeEventListener('mousemove', onMove);
   }, [visible]);

   if (!visible) return null;

   return (
      <>
         <Overlay $show={showOverlay} $side={side} />
         <OverlayText $show={showOverlay} $side={side}>
            {hoverText}
         </OverlayText>

         <Wrap $side={side}>
            <Btn
               type="button"
               onMouseDown={(e) => e.preventDefault()} // ✅ não deixa o input perder foco
               onClick={() => {
                  setHover(false);
                  setArmed(false);
                  onClear?.();
               }}
               disabled={disabled}
               aria-label="Limpar"
               title="Limpar"
               onMouseEnter={() => {
                  if (!armed) return;
                  setHover(true);
               }}
               onMouseLeave={() => setHover(false)}
            >
               ×
            </Btn>
         </Wrap>
      </>
   );
}


InputClearButton.propTypes = {
   visible: PropTypes.bool,
   side: PropTypes.oneOf(['left', 'right']),
   hoverText: PropTypes.string,
   onClear: PropTypes.func,
   disabled: PropTypes.bool,
};
